import { computed, toValue, type MaybeRefOrGetter } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import type { ProductById } from '@/gql/reviews'

export const useRouterQueryInsightsCategory = (product: MaybeRefOrGetter<ProductById>) => {
  const route = useRoute()
  const router = useRouter()

  const options = computed(() => toValue(product).categories.filter((option) => option.published && !option.hidden))
  const defaultSlug = computed(() => toValue(product).mainCategory.slug)

  const category = computed(() => {
    const queried = route.query.category
    if (typeof queried === 'string' && options.value.some((option) => option.slug === queried)) return queried
    return defaultSlug.value
  })

  const selectedCategory = computed(() => {
    const current = toValue(product)
    return current.categories.find((option) => option.slug === category.value) ?? current.mainCategory
  })

  function setCategory(slug: string) {
    router.push({
      query: {
        ...route.query,
        category: slug !== defaultSlug.value ? slug : undefined,
      },
    })
  }

  return { category, options, defaultSlug, selectedCategory, setCategory }
}
